import * as React from "react";

const AccessPage : React.FC = () => {
    const displaySize = window.innerWidth < 600 ? (window.innerWidth - 24) : (window.innerWidth <= 768 ? 456 : 600);
    return (
        <div className={"access-page"}>
            <div>
                <img src={"/images/header_access.png"} className={"header"}/>
            </div>
            <div className={"map"}>
                <img src={"/images/map.gif"} className={"access-map"}/>
                <div className={"detail"}>
                    JR環状線/地下鉄中央線『弁天町』駅より徒歩10分<br/>『港区役所』東側です
                </div>
            </div>
            <h1>JR環状線をご利用の場合</h1>
            <p>
               南口改札を出て、階段を下り43号線を南に、「市岡元町3」交差点を西へ。
            </p>
            <h1>地下鉄中央線をご利用の場合</h1>
            <p>
                3番出口を右へ、43号線を南に、「市岡元町3」交差点を西へ。
            </p>
            <h1>
                大阪市バスをご利用の場合
            </h1>
            <p>
                系統88・88B天保山行 「港区役所前」停留所下車すぐ。
            </p>
            <h1>
                お車でお越しの場合
            </h1>
            <p>
                駐車スペースあります（3台）。
            </p>
            <h1>Google Map</h1>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d820.4106413952729!2d135.46135571833284!3d34.663728760952374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e7cd06a840cf%3A0xc19892750db5f92a!2z44CSNTUyLTAwMTIg5aSn6Ziq5bqc5aSn6Ziq5biC5riv5Yy65biC5bKh77yR5LiB55uu77yR77yU4oiS77yR77yW!5e0!3m2!1sja!2sjp!4v1621515609981!5m2!1sja!2sjp" width={displaySize} height="450" style={{"border":"0"}} loading="lazy" allowFullScreen={true}></iframe>
            <div style={{marginBottom: "50px"}}></div>
        </div>
    );
}

export default AccessPage;
